import { Icon } from '@febos-io/design';
import PropTypes from 'prop-types';

import React from 'react';

export function PanelInformationTextModal({
  title,
  icon,
  toolbar,
  children,
}) {
  return (
    <>
      <div className="row mb-1">
        <div className="col">
          <div className="d-flex align-items-center gap-1 justify-content-between">
            <div className="d-flex align-items-center gap-1">
              <div>
                <Icon icon={icon} fontSize="30" iconLibrary="far" />
              </div>
              <div>
                <h6 className="mb-0">
                  <strong className="d-inline fs-6 text-gray">{title}</strong>
                </h6>
              </div>
            </div>
            {toolbar && (
              <div className="ms-auto">{toolbar}</div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        {children}
      </div>
    </>
  );
}
export default PanelInformationTextModal;

PanelInformationTextModal.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  children: PropTypes.node,
  toolbar: PropTypes.node,
};
